// Bundle PDP thumbnails
function getThumbnailSrcFromSlide(slide) {
  const img = slide.querySelector('img');
  if (!img) return null;

  const srcset = img.getAttribute('srcset');
  if (srcset) {
    const firstSrc = srcset.split(',')[0]?.trim().split(' ')[0];
    if (firstSrc) return firstSrc;
  }

  return img.currentSrc || img.src;
} 

// Bundle composite thumbnail (two-up, or giftbox tall + stacked pair)
function getThumbnailMarkupFromSlide(slide) {
  const giftboxSlots = ['1', '2', '3']
    .map(slot => slide.querySelector(`[data-bundle-slot="${slot}"] img`))
    .filter(Boolean);

  if (giftboxSlots.length) {
    const imgs = giftboxSlots
      .map(img => {
        const top = img.style.top;
        const style = top ? ` style="top: ${top};"` : '';
        return `<img src="${img.getAttribute('src') || ''}" alt="" loading="lazy"${style}>`;
      })
      .join('');
    return `<span class="bundle-thumb-composite bundle-thumb-composite--giftbox">${imgs}</span>`;
  }

  const left = slide.querySelector('[data-bundle-left-image] img');
  const right = slide.querySelector('[data-bundle-right-image] img');

  if (left && right) {
    const imgs = [left, right]
      .map(img => {
        const top = img.parentElement?.style.top;
        const style = top ? ` style="top: ${top};"` : '';
        return `<img src="${img.getAttribute('src') || ''}" alt="" loading="lazy"${style}>`;
      })
      .join('');
    return `<span class="bundle-thumb-composite">${imgs}</span>`;
  }

  const src = getThumbnailSrcFromSlide(slide);
  return src ? `<img src="${src}" alt="" loading="lazy">` : '';
}

function getMediaIndexFromSlide(slide) {
  const idx = Number(slide?.dataset.mediaIndex);
  return Number.isNaN(idx) ? null : idx;
}

function getCarouselSlides() {
  const wrapper = document.querySelector(
    '.product .carousel_product .swiper-wrapper'
  );
  return wrapper
    ? Array.from(wrapper.querySelectorAll(':scope > .swiper-slide'))
    : [];
}

function getActiveProductMediaIndex(swiper = window.productSwiper) {
  if (!swiper) return 0;
  return (
    getMediaIndexFromSlide(swiper.slides?.[swiper.activeIndex]) ??
    swiper.activeIndex ??
    0
  );
}

function scrollThumbnailColumnToActive(mediaIndex) {
  const container = document.querySelector('.product__media-thumbnails');
  const btn = container?.querySelector(`[data-media-index="${mediaIndex}"]`);
  if (!container || !btn) return;

  const pad = 16;
  const viewTop = container.scrollTop;
  const viewBottom = viewTop + container.clientHeight;
  const btnTop = btn.offsetTop;
  const btnBottom = btnTop + btn.offsetHeight;

  if (btnTop - pad < viewTop) {
    container.scrollTo({ top: btnTop - pad, behavior: 'smooth' });
  } else if (btnBottom + pad > viewBottom) {
    container.scrollTo({
      top: btnBottom + pad - container.clientHeight,
      behavior: 'smooth'
    });
  }
}

function syncProductThumbnails(mediaIndex = 0) {
  document.querySelectorAll('.product__media-thumbnail').forEach(btn => {
    btn.classList.toggle(
      'is-active',
      Number(btn.dataset.mediaIndex) === mediaIndex
    );
  });

  scrollThumbnailColumnToActive(mediaIndex);
}

function syncProductThumbnailsFromSwiper(swiper = window.productSwiper) {
  syncProductThumbnails(getActiveProductMediaIndex(swiper));
}

function goToProductSlide(mediaIndex) {
  const swiper = window.productSwiper;
  if (!swiper || mediaIndex == null || Number.isNaN(mediaIndex)) return;

  const slideIndex = Array.from(swiper.slides).findIndex(
    slide => getMediaIndexFromSlide(slide) === mediaIndex
  );
  if (slideIndex < 0) return;

  swiper.slideTo(slideIndex, swiper.params.speed ?? 300);
  syncProductThumbnails(mediaIndex);
}

function initProductThumbnailsFromSlides() {
  const container = document.querySelector(
    '.product__carousel--carousel_thumbnails .product__media-thumbnails'
  );
  if (!container) return;

  const slides = getCarouselSlides();
  container.innerHTML = '';

  slides.forEach((slide, index) => {
    const mediaIndex = getMediaIndexFromSlide(slide) ?? index;
    const inner = getThumbnailMarkupFromSlide(slide);
    if (!inner) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product__media-thumbnail';
    btn.dataset.mediaIndex = String(mediaIndex);
    btn.setAttribute('aria-label', `View image ${mediaIndex + 1}`);
    btn.innerHTML = inner;
    btn.addEventListener('click', event => {
      event.preventDefault();
      goToProductSlide(mediaIndex);
    });
    container.appendChild(btn);
  });

  container.style.display = slides.length > 1 ? '' : 'none';
  syncProductThumbnailsFromSwiper();
}

const PRODUCT_MOBILE_MQ = '(max-width: 1023px)';
let mobileThumbsState = null;

function initProductMobileThumbs() {
  if (mobileThumbsState) return;

  const root = document.querySelector('.product__thumbs-slider');
  const wrapper = root?.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  function syncActiveFromMain() {
    if (!mobileThumbsState) return;

    const activeIndex = getActiveProductMediaIndex();
    let activePosition = -1;

    Array.from(wrapper.children).forEach((thumb, position) => {
      const isActive = Number(thumb.dataset.mediaIndex) === activeIndex;
      thumb.classList.toggle('is-active', isActive);
      if (isActive) activePosition = position;
    });

    if (activePosition >= 0 && root.swiper) {
      root.swiper.slideTo(activePosition);
    }
  }

  function onThumbClick(event) {
    const thumb = event.target.closest('.product__thumb');
    if (!thumb) return;

    event.preventDefault();
    goToProductSlide(Number(thumb.dataset.mediaIndex));
    syncActiveFromMain();
  }

  function initThumbsSwiper() {
    if (!mobileThumbsState || root.swiper) return;

    if (typeof Swiper !== 'function') {
      window.whenSwiperReady?.(initThumbsSwiper);
      return;
    }

    new Swiper(root, {
      slidesPerView: 7,
      spaceBetween: 8,
      watchOverflow: true,
      slidesPerGroup: 1
    });
    syncActiveFromMain();
  }

  function attachMainSwiperSync() {
    if (!mobileThumbsState) return;

    if (window.productSwiper) {
      window.productSwiper.on('slideChange', syncActiveFromMain);
      syncActiveFromMain();
      return;
    }

    mobileThumbsState.syncTimer = setTimeout(attachMainSwiperSync, 100);
  }

  wrapper.innerHTML = getCarouselSlides()
    .map(slide => {
      const mediaIndex = getMediaIndexFromSlide(slide);
      const inner = getThumbnailMarkupFromSlide(slide);
      if (mediaIndex == null || !inner) return '';

      return `<button type="button" class="swiper-slide product__thumb" data-media-index="${mediaIndex}" aria-label="View image ${mediaIndex + 1}">${inner}</button>`;
    })
    .join('');

  root.style.display = wrapper.children.length > 1 ? '' : 'none';
  wrapper.addEventListener('click', onThumbClick);

  mobileThumbsState = {
    root,
    wrapper,
    onThumbClick,
    syncActiveFromMain,
    syncTimer: null
  };

  attachMainSwiperSync();
  initThumbsSwiper();
}

function destroyProductMobileThumbs() {
  if (!mobileThumbsState) return;

  const { root, wrapper, onThumbClick, syncActiveFromMain, syncTimer } =
    mobileThumbsState;

  clearTimeout(syncTimer);
  wrapper.removeEventListener('click', onThumbClick);
  window.productSwiper?.off('slideChange', syncActiveFromMain);
  root.swiper?.destroy(true, true);
  root.style.display = '';
  wrapper.innerHTML = '';

  mobileThumbsState = null;
}

function watchProductMobileCarousels() {
  const mql = window.matchMedia(PRODUCT_MOBILE_MQ);
  const sync = () =>
    mql.matches ? initProductMobileThumbs() : destroyProductMobileThumbs();

  mql.addEventListener('change', sync);
  sync();
}

// main.js calls this on slide change
window.syncProductThumbnailsFromSwiper = syncProductThumbnailsFromSwiper;

// Re-render the two-bottle thumb after a swatch change
function refreshCompositeThumbs() {
  const slide = document
    .querySelector(
      '.bundle-product .carousel_product [data-bundle-slot="1"], .bundle-product .carousel_product [data-bundle-left-image]'
    )
    ?.closest('.swiper-slide');
  if (!slide) return;

  const markup = getThumbnailMarkupFromSlide(slide);
  document.querySelectorAll('.bundle-thumb-composite').forEach(el => {
    el.outerHTML = markup;
  });
}

function waitForMainSwiper(attempt = 0) {
  if (window.productSwiper) {
    syncProductThumbnailsFromSwiper();
    return;
  }
  if (attempt < 100) setTimeout(() => waitForMainSwiper(attempt + 1), 50);
}

if (document.querySelector('.bundle-product .product__carousel--carousel_thumbnails')) {
  document.addEventListener('bundle:variant-change', refreshCompositeThumbs);
  initProductThumbnailsFromSlides();
  watchProductMobileCarousels();
  waitForMainSwiper();
}
